import React, { useState } from 'react'
import CaretDown from 'components/shared/icons/CaretDown'
import CaretUp from 'components/shared/icons/CaretUp'

const JUMBO_LOAN_AMOUNT = 766550

const ImportantInformation = () => {
  const [toggle, setToggle] = useState(false)

  const jumboAmountWithCommas = JUMBO_LOAN_AMOUNT.toLocaleString('en-US')

  return (
    <div className="my-6 md:border-gray md:border-t">
      <button
        onClick={() => setToggle(!toggle)}
        className="Button Button-reset font-circular-book display-flex justify-content-space-between pb-0 w-full max-w-full"
        style={{ fontSize: '16px' }}
        aria-controls="details-one"
        aria-expanded="false"
        data-toggle="trigger"
      >
        <span>Important information about our rate tables</span>

        {toggle ? (
          <CaretUp extraClasses="fill-blue Icon Icon--xs mt-1 md:mt-0" />
        ) : (
          <CaretDown extraClasses="fill-blue Icon Icon--xs mt-1 md:mt-0" />
        )}
      </button>
      {toggle && (
        <div className="px-6">
          <p className="pt-6 text-slate type-body-three">
            <span className="font-circular-bold">About our Mortgage Rate Tables:</span> The above mortgage loan
            information is provided to, or obtained by, Bankrate. Some lenders provide their mortgage loan terms to
            Bankrate for advertising purposes and Bankrate receives compensation from those advertisers (our
            "Advertisers"). Other lenders' terms are gathered by Bankrate through its own research of available mortgage
            loan terms and that information is displayed in our rate table for applicable criteria. In the above table,
            an Advertiser listing can be identified and distinguished from other listings because it includes a "Next"
            button that can be used to click-through to the Advertiser's own website or a phone number for the
            Advertiser.
          </p>
          <p className="text-slate type-body-three">
            <span className="font-circular-bold">Availability of Advertised Terms:</span> Each Advertiser is responsible
            for the accuracy and availability of its own advertised terms. Bankrate cannot guaranty the accuracy or
            availability of any loan term shown above. However, Bankrate attempts to verify the accuracy and
            availability of the advertised terms through its quality assurance process and requires Advertisers to agree
            to our Terms and Conditions and to adhere to our Quality Control Program.{' '}
            <a
              className="display-inline-block Link Link--standalone text-size-xs"
              href="https://www.bankrate.com/mortgages/product-criteria/?prodtype=mtg"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here for rate criteria by loan product.
            </a>
          </p>
          <p className="text-slate type-body-three">
            <span className="font-circular-bold">Loan Terms for Bankrate.com Customers:</span> Advertisers may have
            different loan terms on their own website from those advertised through Bankrate.com. To receive the
            Bankrate.com rate, you must identify yourself to the Advertiser as a Bankrate.com customer. This will
            typically be done by phone so you should look for the Advertisers phone number when you click-through to
            their website. In addition, credit unions may require membership.
          </p>
          <p className="text-slate type-body-three">
            <span className="font-circular-bold">
              Loans Above ${jumboAmountWithCommas} May Have Different Loan Terms:{' '}
            </span>
            If you are seeking a loan for more than ${jumboAmountWithCommas}, lenders in certain locations may be able
            to provide terms that are different from those shown in the table above. You should confirm your terms with
            the lender for your requested loan amount.
          </p>
          <p className="text-slate type-body-three">
            <span className="font-circular-bold">Taxes and Insurance Excluded from Loan Terms:</span> The loan terms
            (APR and Payment examples) shown above do not include amounts for taxes or insurance premiums. Your monthly
            payment amount will be greater if taxes and insurance premiums are included.
          </p>
          <p className="text-slate type-body-three">
            <span className="font-circular-bold">Consumer Satisfaction:</span> If you have used Bankrate.com and have
            not received the advertised loan terms or otherwise been dissatisfied with your experience with any
            Advertiser, we want to hear from you. Please{' '}
            <a
              className="display-inline-block Link Link--standalone text-size-xs"
              href="mailto:qualitycontrol@bankrate.com"
            >
              click here
            </a>{' '}
            to provide your comments to Bankrate Quality Control.
          </p>
        </div>
      )}
    </div>
  )
}

export default ImportantInformation
